var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-binding-store"},[_c('p',[_vm._v("暂未绑定门店")])])
}]

export { render, staticRenderFns }